import isEqual from 'lodash.isequal';
import getHash from '../internal/get-hash';
var initialStateManager = new Map();

var getSelectorKey = function getSelectorKey(selector) {
  if (typeof selector === 'string') {
    return selector;
  }

  var _selector$query = selector.query,
      name = _selector$query.name,
      resolver = _selector$query.resolver,
      args = _selector$query.args;
  return getHash(name) + ":" + getHash(resolver) + ":" + getHash(args);
};

export var setSelectorState = function setSelectorState(selector, state) {
  var key = getSelectorKey(selector);
  var entry = initialStateManager.get(key);

  if (entry != null) {
    if (!isEqual(entry.state, state)) {
      throw Error("initial states conflict, check useReduxReadModel hook calls");
    }

    entry.references++;
  } else {
    initialStateManager.set(getSelectorKey(selector), {
      references: 1,
      state: state
    });
  }
};
export var getSelectorState = function getSelectorState(selector) {
  var entry = initialStateManager.get(getSelectorKey(selector));

  if (entry != null) {
    return entry.state;
  }

  return null;
};
export var releaseSelectorState = function releaseSelectorState(selector) {
  var entry = initialStateManager.get(getSelectorKey(selector));

  if (entry != null) {
    entry.references--;

    if (entry.references === 0) {
      initialStateManager["delete"](getSelectorKey(selector));
    }
  }
};
//# sourceMappingURL=initial-state-manager.js.map